<template>
    <div>
        <!-- ●●●上部メニュー●●● -->
        <Header :type="menu_type" :title="title" />
        <div class="container-fluid px-4 py-4 min-vh-85">
        <!-- ●●●コンテンツ●●● -->
        <div class="mt-0">
            <!-- ●●●メインコンテンツ●●● -->
            <div id="content-menu" class="my-2 mx-0" role="main">
                <!-- ●●●1件目●●● -->
                <section class="" id="menu-1">
                    <!-- ●●●メニュータイトル●●● -->
                    <div class="user-header alt bg-none">
                        <div class="media">
                            <div class="media-body pb-3">
                                <h5 class="text-secondary m-0"><span class="oi oi-cart"></span> 問合せ処理メニュー</h5>
                            </div>
                        </div>
                    </div>
                    <!-- ●●●メニュー●●● -->
                    <div id="collapse-menu0" class="row collapse show">
                        <div id="sort0" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;flex-wrap:wrap;"
                            v-shortkey="['1']" @shortkey="executeShortcut('sales-slip-inquiry')">
                            <router-link to="/sales-slip-inquiry"
                                class="list-group-item list-group-item-action flex-fill flex-column align-items-start p-3 mb-2"
                                data-id="1" id="menu1-1">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">1</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">売上伝票照会</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>伝票の再発行を含む</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                        <div id="sort0" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;flex-wrap:wrap;"
                            v-shortkey="['2']" @shortkey="executeShortcut('invoice-inquiry')">
                            <router-link to="/invoice-inquiry"
                                class="list-group-item list-group-item-action flex-fill flex-column align-items-start p-3 mb-2"
                                data-id="2" id="menu1-2">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">2</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">得意先元帳照会</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>得意先毎の売上伝票の一覧を表示します。</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                        <div id="sort0" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;flex-wrap:wrap;"
                            v-shortkey="['3']" @shortkey="executeShortcut('client-ledger-inquiry')">
                            <router-link to="/client-ledger-inquiry"
                                class="list-group-item list-group-item-action flex-fill flex-column align-items-start p-3 mb-2"
                                data-id="3" id="menu1-3">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">3</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">仕入先元帳照会</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>仕入先毎の仕入伝票の一覧を表示します。</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                        <div id="sort0" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;flex-wrap:wrap;"
                            v-shortkey="['4']" @shortkey="executeShortcut('ships-confirm-inquiry')">
                            <router-link to="/ships-confirm-inquiry"
                                class="list-group-item list-group-item-action flex-fill flex-column align-items-start p-3 mb-2"
                                data-id="4" id="menu1-4">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">4</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">出荷確定照会</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>出荷確定したデータの一覧</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                        <div id="sort0" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;"
                            v-shortkey="['5']" @shortkey="executeShortcut('order-inquiry')">
                            <router-link to="/order-inquiry"
                                class="list-group-item list-group-item-action align-items-start p-3 mb-2"
                                data-id="5" id="menu1-5">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">5</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">発注照会</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>発注の履歴を表示</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                        <div id="sort2" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;"
                            v-shortkey="['6']" @shortkey="executeShortcut('received-order-inquiry')">
                            <router-link to="/received-order-inquiry"
                                class="list-group-item list-group-item-action flex-fill flex-column align-items-start p-3 mb-2"
                                data-id="6" id="menu1-6">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">6</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">受注照会 通常/製品別/チェック用</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>検索条件毎の受注の一覧を表示します。</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <Footer />
    </div>
</template>
<script>
import Header from '@/components/navigation/header.vue';
import Footer from '@/components/navigation/footer.vue';
import {init} from '@/assets/js/common.js'
export default {
  name: 'MENU-SALES-INQUIRY',
  /** コンポーネント */
  components: {
    Header,
    Footer
  },
  /** データ */
  data() {
    return {
      // ヘッダ
      menu_type: 'user',
      title: '問合せ処理メニュー',
    }
  },
  /* マウント */
  mounted() {
    init(); // common.jsにて初期化処理
    this.$store.commit('setLoading', false);
  },
  methods: {
    // ショートカットキー押下時処理
    executeShortcut(path) {
      // パスを受け取って遷移
      console.log('shortcut');
      this.$router.push(`/${path}`);
    },
  },
}
</script>